import { BaseModel, EntityProperty } from '@tcc-mono/shared/data-access';
import { RelationType } from './relation-type.model';

export class Relation extends BaseModel {
  bank: string;
  bank_account: string;
  bright_deptor_id: number;
  coc_number: string;
  contact_person_email: string;
  contact_person_name: string;
  contact_person_phone: string;
  created_at: string;
  direct_debit: string;
  exact_code: string;
  id: number;
  invoice_address: string;
  invoice_city: string;
  invoice_country?: string;
  invoice_email: string;
  invoice_name: string;
  invoice_phone: string;
  invoice_relation_id: string;
  invoice_zip: string;
  invoice_no_vat: boolean;
  invoice_show_weight: boolean;
  name: string;
  nvwa_recognition_number?: string;
  payment_method: string;
  payment_period: string;
  postal_address: string;
  postal_city: string;
  postal_country?: string;
  postal_email: string;
  postal_name: string;
  postal_phone: string;
  postal_zip: string;
  properties: EntityProperty[];
  relation_number: string;
  relation_type_code: string;
  relation_type_id: string;
  relation_type?: RelationType;
  remarks: string;
  send_invoice_to_email: boolean;
  updated_at: string;
  vat_arrangement: string;
  vat_number: string;
  visit_address: string;
  visit_city: string;
  visit_country?: string;
  visit_email: string;
  visit_name: string;
  visit_phone: string;
  visit_zip: string;
  direct_stable_purchase: boolean;
  weighing_slip: boolean;
  inactive: boolean;
  veevolg_mail?: string;
  bright_mail?: string;
  tcs_mail?: string;
  animal_transfer_mail?: string;
  /** Alleen op relations.show; of relatie ooit ergens heeft geladen. */
  has_loading_ubns?: boolean;
}
